.search {
  display: flex;
  gap: 8px;
  align-items: center;
}

.input {
  width: 248px;
  padding-block: 2px;
  font-size: var(--font-size-sm);
  color: white;
  background-color: transparent;

  &:focus {
    outline: none;
    border: none;
  }

  &::placeholder {
    color: #d0d5e0;
  }
}

.form {
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  border-bottom: 1px solid var(--color-white);
  transition: width 0.2s;
}

.collapseIcon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.button {
  display: flex;
  align-items: center;
  padding: 1px;
}
